module.exports = __webpack_public_path__ + "static/img/no_review_icon.436a51bb.svg";